import { maybeUpdateSingleSelectOptions } from '../utils/variantSelectChangeEvent';

function toggleCheckboxState(checkbox: Element, singleSelector: string): void {
  if (!(checkbox instanceof HTMLInputElement)) {
    return;
  }

  const label = checkbox.closest('.check-box');

  if ('checked' in checkbox && checkbox.checked) {
    label?.classList.add('check-box--checked');
    checkbox.ariaChecked = 'true';
    maybeUpdateSingleSelectOptions(checkbox.value, singleSelector);
  } else {
    label?.classList.remove('check-box--checked');
    checkbox.ariaChecked = 'false';
    maybeUpdateSingleSelectOptions(checkbox.value, singleSelector, true);
  }
}

export function initCheckboxModule(): void {
  const checkboxes = document.querySelectorAll(
    '.check-box input[type=checkbox]'
  );
  checkboxes.forEach((checkbox) => {
    if (!(checkbox instanceof HTMLInputElement)) {
      return;
    }

    const singleSelector = checkbox.dataset.singleSelector;

    if (!singleSelector) {
      return;
    }

    toggleCheckboxState(checkbox, singleSelector);

    checkbox.addEventListener('change', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }

      document
        .querySelectorAll(
          `.check-box input[data-single-selector=${singleSelector}]`
        )
        .forEach((checkbox) => {
          if (!(checkbox instanceof HTMLInputElement)) {
            return;
          }
          checkbox
            ?.closest('.check-box')
            ?.classList.remove('check-box--checked');
          checkbox.ariaChecked = 'false';
          if (checkbox.id !== target.id) {
            checkbox.checked = false;
          }
        });

      toggleCheckboxState(target, singleSelector);
    });
  });
}
